import React from 'react';
import Masonry from 'react-masonry-component';
import { Card } from 'react-bootstrap';
import { useQuery } from '@apollo/client';
import { useHistory } from 'react-router-dom';

import { Can } from '../../../../components/Can/Can';
import { permissions } from '../../../../components/Can/rbac-rules';
import { UserRequests } from '../UserRequests';
import { addWidgetBarCounts, salvageCount, transferWidgetBarCounts } from '../../api';

export const AssetProgressionWidgetBar = ({ user, request, itAdmin }) => {
  return (
    <div style={{ flex: 1, flexDirection: 'row' }}>
      {!itAdmin ? null : (
        <div className='m-2'>
          <Can
            role={user.currentRole}
            roles={user.roles}
            perform={permissions.transfer}
            yes={() => <h2>Ordering/Receiving</h2>}
            no={NoAccessElement}
            data={{}}
          />
          {/* <h2>Ordering/Receiving</h2>*/}
          <AddBar user={user} />
        </div>
      )}
      <div className='m-2'>
        <Can
          role={user.currentRole}
          roles={user.roles}
          perform={permissions.transfer}
          yes={() => <h2 className='mt-2'>Transfers</h2>}
          no={NoAccessElement}
          data={{}}
        />
        <TransferBar user={user} />
      </div>
      {!itAdmin ? null : (
        <div className='m-2'>
          <SalvageBar user={user} />
        </div>
      )}
    </div>
  );
};

const AddBar = ({ user }) => {
  const { error, data } = useQuery(addWidgetBarCounts(user.currentRole.departmentId, user.currentRole.departmentAbbreviation));

  if (error) {
    return <div>Error</div>;
  }

  // consider all of the users roles? or the one they're currently on?
  var requestsCount = -1; // deptID
  var ordersCount = -1; // deptID
  var receivedBarcodeCount = -1; // deptName or deptAbbreviation
  var receivedNonBarcodeCount = -1; // deptName or deptAbbreviation. what is the needsBarcode boolean in the db
  var eoneReadyCount = -1; // deptName or deptAbbreviation OR toDeptId?
  var successCount = -1;
  var errorsCount = -1;

  if (data) {
    requestsCount = data.requests_count;
    ordersCount = data.orders_count;
    receivedBarcodeCount = data.barcoded_count;
    receivedNonBarcodeCount = data.nonBarcoded_count;
    eoneReadyCount = data.eoneReady_count;
    successCount = data.success_count;
    errorsCount = data.errors_count;
  }

  return (
    <>
      <Masonry>
        {/* <div>Add</div> */}
        <WidgetCard
          user={user}
          data={{ count: requestsCount, title: 'Requested', /*  className: 'rec-link', */ to: '/requests' /* , linkTitle: 'Requested Card' */ }}
        />
        <WidgetCard
          user={user}
          data={{ count: ordersCount, title: 'Ordered', /*  className: 'rec-link', */ to: '/requests/ordered' /* , linkTitle: 'Requested Card' */ }}
        />
        <WidgetCard
          user={user}
          data={{
            // count: -1,
            title: 'Received',
            /*  className: 'rec-link', */
            // to: '/receiving',
            /* linkTitle: 'Requested Card', */
            isSplit: true,
            subTitleOne: 'Barcoded',
            subTitleTwo: 'Non-Barcoded',
            toOne: '/requests/barcoded',
            toTwo: '/requests/nonBarcoded',
            countOne: receivedBarcodeCount,
            countTwo: receivedNonBarcodeCount,
          }}
        />
        <WidgetCard
          user={user}
          data={{
            count: eoneReadyCount,
            title: 'E-One Ready',
            /*  className: 'rec-link', */ to: '/requests/eOneReady' /* , linkTitle: 'Requested Card' */,
          }}
        />
        <WidgetCard
          user={user}
          data={{
            // count: -1,
            title: 'Reports',
            /*  className: 'rec-link', */
            to: '/receiving',
            /* linkTitle: 'Requested Card', */
            isSplit: true,
            subTitleOne: 'Success',
            subTitleTwo: 'Errors',
            toOne: '/requests/eOneSuccess',
            toTwo: '/requests/eOneErrors',
            countOne: successCount,
            countTwo: errorsCount,
          }}
        />
      </Masonry>
    </>
  );
};

const TransferBar = ({ user }) => {
  const { error, data } = useQuery(transferWidgetBarCounts(user.currentRole.departmentId));

  if (error) {
    return <div>Error</div>;
  }

  var initiatedCount = -1;
  var recievedCount = -1;
  var pendingApprovalCount = -1;
  var eoneReadyCount = -1;
  var successCount = -1;
  var errorCount = -1;

  if (data) {
    initiatedCount = data.transferInitiated_count;
    recievedCount = data.transferRecieved_count;
    pendingApprovalCount = data.transferPendingApproval_count;
    eoneReadyCount = data.transferReadyForEOne_count;
    successCount = data.transferSuccess_count;
    errorCount = data.transferErrors_count;
  }

  //   '/transfers' exact
  // '/transfers/recieved'
  // '/transfers/pendingApproval'
  // '/transfers/eOneReady'
  // '/transfers/eOneSuccess'
  // '/transfers/eOneErrors'

  return (
    <Masonry>
      {/* <div>Transfer</div> */}
      <WidgetCard
        user={user}
        data={{ count: initiatedCount, title: 'Initiated', /*  className: 'rec-link', */ to: '/transfers' /* , linkTitle: 'Requested Card' */ }}
      />
      <WidgetCard
        user={user}
        data={{
          count: recievedCount,
          title: 'Received',
          /*  className: 'rec-link', */ to: '/transfers/recieved' /* , linkTitle: 'Requested Card' */,
        }}
      />
      <WidgetCard
        user={user}
        data={{
          count: pendingApprovalCount,
          title: 'Installed, Pending Approval',
          /*  className: 'rec-link', */ to: '/transfers/pendingApproval' /* , linkTitle: 'Requested Card' */,
        }}
      />
      <WidgetCard
        user={user}
        data={{
          count: eoneReadyCount,
          title: 'E-One Ready',
          /*  className: 'rec-link', */ to: '/transfers/eOneReady' /* , linkTitle: 'Requested Card' */,
        }}
      />
      <WidgetCard
        user={user}
        data={{
          // count: -1,
          title: 'Reports',
          /*  className: 'rec-link', */
          // to: '/receiving',
          /* linkTitle: 'Requested Card', */
          isSplit: true,
          subTitleOne: 'Success',
          subTitleTwo: 'Errors',
          toOne: '/transfers/eOneSuccess',
          toTwo: '/transfers/eOneErrors',
          countOne: successCount,
          countTwo: errorCount,
        }}
      />
    </Masonry>
  );
};

const SalvageBar = ({ user }) => {
  const { data, error } = useQuery(salvageCount);

  if (error) {
    return <div>Error</div>;
  }

  let salvageNumber = -1;
  //if (requestsResults.loading) return <p>Loading...</p>;
  // // console.log(requestsResults.data);
  if (data) salvageNumber = data.salvageCount;

  return (
    <Masonry>
      <WidgetCard
        user={user}
        data={{ count: salvageNumber, title: 'Salvage', /*  className: 'rec-link', */ to: '/salvage' /* , linkTitle: 'Requested Card' */ }}
      />
    </Masonry>
  );
};

const NoAccessElement = () => {
  return null;
};

const WidgetCard = ({ user, data }) => {
  if (data.isSplit) {
    return (
      <Can
        role={user.currentRole}
        roles={user.roles}
        perform={permissions.transfer}
        yes={SplitCountCard}
        no={NoAccessElement} // ????
        data={{
          count: data.count,
          title: data.title,
          // className: data.className,
          // to: data.to,
          // linkTitle: data.linkTitle,
          subTitleOne: data.subTitleOne,
          subTitleTwo: data.subTitleTwo,
          toOne: data.toOne,
          toTwo: data.toTwo,
          countOne: data.countOne,
          countTwo: data.countTwo,
        }}
      />
    );
  }

  return (
    <Can
      role={user.currentRole}
      roles={user.roles}
      perform={permissions.transfer}
      yes={CountCard}
      no={NoAccessElement} // ????
      data={{ count: data.count, title: data.title, /* className: data.className, */ to: data.to /* , linkTitle: data.linkTitle */ }}
    />
  );
};

const CountCard = (props) => {
  const history = useHistory();

  return (
    <div>
      <Card
        border={props.border}
        className='grid-card card widget'
        style={{ width: 200, height: 165 }}
        onClick={() => {
          history.push(props.to);
        }}>
        <Card.Header style={{ paddingLeft: 10 }}>{props.title}</Card.Header>
        <Card.Body>
          <Card.Text style={{ fontSize: 25, textAlign: 'center', paddingTop: 15 }}>{props.count}</Card.Text>
        </Card.Body>
      </Card>
    </div>
  );
};

const SplitCountCard = (props) => {
  const history = useHistory();
  const [top, setTop] = React.useState('black');
  const [bottom, setBottom] = React.useState('black');

  const handleHover = (firstElement) => {
    if (firstElement) {
      setTop('black');
      setBottom('lightgrey');
    } else {
      setTop('lightgrey');
      setBottom('black');
    }
  };

  const handleHoverExit = () => {
    setTop('black');
    setBottom('black');
  };

  return (
    <div>
      <Card
        border={props.border}
        className='grid-card card widget'
        style={{ width: 200, height: 165 }}
        onMouseLeave={() => handleHoverExit()}
        /* onClick={() => {
          history.push(props.to);
        }} */
      >
        <Card.Header style={{ paddingLeft: 10 }}>{props.title}</Card.Header>
        <Card.Body>
          <div
            style={{ fontSize: 15, textAlign: 'center', color: top }}
            onMouseEnter={() => handleHover(true)}
            onClick={() => history.push(props.toOne)}>
            {`${props.subTitleOne}: ${props.countOne}`}
          </div>
          <hr />
          <div
            style={{ fontSize: 15, textAlign: 'center', color: bottom }}
            onMouseEnter={() => handleHover(false)}
            onClick={() => history.push(props.toTwo)}>
            {`${props.subTitleTwo}: ${props.countTwo}`}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

// add
// requested
// ordered
// recieved(barcode/nonbarcode)
// e1ready
// success/errors

// transfer
// initiated
// recieved
// appending approval
// ready for e1
// success/errors

// tooltips info

// -----------------------
// select * from REQUEST where (requestingDepartmentId=19 or fulfillingDepartment=19) and status='Requested' order by requestId desc

// select * from REQUEST where status='Requested' order by requestId desc

// select * from REQUEST where status ='Ordered'

// select * from REQUESTED_ITEM where status='Barcoded' order by requestedItemId desc

// select * from REQUESTED_ITEM where department='OIT' order by requestedItemId desc

// select * from ENTERPRISE_ONE_UPDATES where department='OIT' order by updateId desc

// select * from ENTERPRISE_ONE_UPDATES where updateType='A' and updateStatus = 'Import Successful'

// select distinct updateStatus from ENTERPRISE_ONE_UPDATES
